import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Legend, Tooltip, ResponsiveContainer } from "recharts";
import { useSentimentAnalysisApi } from '../../store/api/hooks/sentimentAnalysisApiHook';
import { useAuthStatus, useStoreSelector, useStoreBrnDSSelector } from '../../store/selectors/userSelector';
import { toast } from 'react-hot-toast';
import moment from 'moment';
import { RatingStarsResponse } from '../../_config/interfaces/interfaces';


const ReviewStars = ({ filterValue, onOverallAvgRating }: { filterValue: any, onOverallAvgRating: (average: number) => void }) => {
    const [ratingStars, setRatingStars] = useState<RatingStarsResponse>({ feedback_ratings_by_date: [] });
    const [isOnSubmitLoading, setOnSubmitLoading] = useState<boolean>(false);

    const sentimentAPI: any = useSentimentAnalysisApi();
    const navigate = useNavigate();
    const isAuth = useAuthStatus();
    const branchDS = useStoreBrnDSSelector();
    // console.log('useEffect =>', branchDS);

    useEffect(() => {
        if (filterValue !== null) {
            applyFilter(filterValue); // This is called automatically when filterValue changes
        } else {
            getRatingStars({});
        }
    }, [filterValue]);

    const applyFilter = (filterValue: any) => {
        getRatingStars(filterValue);
    }

    const getRatingStars = (param: any) => {
        setOnSubmitLoading(true);
        let params: any;
        if (param) {
            params = { branch_id: branchDS?.branch_id, ...param };
        } else {
            params = { branch_id: branchDS?.branch_id };
        }
        try {
            setTimeout(() => {
                sentimentAPI.getRatingStars(params, (msg: any, resp: any) => {
                    // console.log('response =>', resp, msg);
                    setRatingStars(resp.data);
                    onOverallAvgRating(resp?.data?.overall_avg_rating);
                }, (err: any, resp: any) => {
                    toast.error(resp?.detail?.message);
                })
                setOnSubmitLoading(false);
            }, 3000);

        } catch (err: any) {
            toast.error(err);
            setOnSubmitLoading(false);
        }
    }


    const formatDate = (date: string) => {
        return moment(date).format('DD MMM');
    }

    const generateDynamicTicks = (data: any) => {
        if (!data || data.length === 0) return [0];  // Return 0 if no data

        const maxRating = Math.max(...data.map((d: { avg_rating: number }) => d.avg_rating));  // Get the max rating
        const step = 0.5;  // Define step size for ticks
        const ticks = [];

        // Generate ticks starting from 0 and incrementing by step size
        for (let i = 0; i <= maxRating; i += step) {
            ticks.push(parseFloat(i.toFixed(1)));  // Ensure one decimal place
        }

        return ticks;
    }

    return (
        ratingStars?.feedback_ratings_by_date.length > 0 && (<div>
            <ResponsiveContainer width={"100%"} height={300}>
                <AreaChart
                    width={200}
                    height={60}
                    data={ratingStars?.feedback_ratings_by_date}
                    margin={{
                        top: 5,
                        right: 0,
                        left: 0,
                        bottom: 5
                    }}
                >
                    <XAxis dataKey="date" tickFormatter={formatDate} />
                    <YAxis domain={[0, 'dataMax']}
                        tickFormatter={(value) => value.toFixed(1)}
                        ticks={generateDynamicTicks(ratingStars?.feedback_ratings_by_date)} />
                    <Tooltip />
                    <Legend />
                    <Area type="monotone" dataKey="avg_rating" stroke="#f87171" fill="#f87171" />
                </AreaChart>
            </ResponsiveContainer>
        </div>
        )
    );
}

export default ReviewStars;